import React from "react";
import LivingImage from "./LivingImage";

/**
 * ParallaxImage — thin wrapper around LivingImage retained for API compatibility.
 *
 * Phase 4 elevated every non-hero image to the shared LivingImage treatment
 * (Ken Burns, drift, reflection sweep, spring-damped parallax, color-temp shift).
 * ParallaxImage now composes LivingImage internally so the existing four call
 * sites (Home Philosophy, Strategy Characteristics / Energy narrative / Pull
 * quote) inherit the full five-layer motion without any consumer changes.
 *
 * The `range` prop from the pre-Phase-4 API is ignored — LivingImage's parallax
 * range is tuned centrally. `overlayStyle` is still honoured for contrast
 * gradients the callers rely on.
 */
export const ParallaxImage = ({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  // eslint-disable-next-line no-unused-vars
  range,
  overlayStyle,
}) => {
  return (
    <LivingImage
      src={src}
      alt={alt}
      className={className}
      imgClassName={imgClassName}
      variant="editorial"
      parallax
      overlayStyle={overlayStyle}
    />
  );
};

export default ParallaxImage;
